import { emojisByCategory } from 'rn-emoji-keyboard';

const quickReactions = {
    "thumbs up": "👍",
    "thumbs down": "👎",
    "red heart": "❤️",
    "face with tears of joy": "😂",
    "folded hands": "🙏"
}

const emojiReactions = emojisByCategory.reduce((acc, category) => {
    category.data.forEach(emoji => acc[emoji.name] = emoji.emoji);
    return acc;
}, {});

const getReactionMutation = (name, reactions, userID) => {
    let currentReactions = reactions

    let newReactionArray = currentReactions ? [...(currentReactions[name] || [])] : [];
    let currentUserIndex = newReactionArray.indexOf(userID);

    if(currentUserIndex > -1){
        newReactionArray.splice(currentUserIndex, 1) 
    }
    else{
        if(currentReactions){
            //Remove any other emojis the user has selected on this message
            Object.entries(currentReactions).forEach(([emojiName, people]) => {
                let currentUserIndexOthers = people.indexOf(userID);
                if(currentUserIndexOthers > -1){
                    currentReactions[emojiName].splice(currentUserIndexOthers, 1) 
                }
            })
        }

        newReactionArray = [
            ...newReactionArray,
            userID
        ]
    }

    return {
        ...currentReactions,
        [name]: newReactionArray
    }
}


export {
    quickReactions,
    emojiReactions,
    getReactionMutation
}